<template>
  <label class="station-container">
    Select Station:
    <div class="result">
      <select @change="updateStation" name="dropdown">
        <option value></option>
        <option
          v-for="station in stations"
          :key="station.id"
          :value="station.id"
          required
          :selected="station.id === selectedStation"
        >{{ station.name }}</option>
      </select>
    </div>
  </label>
</template>

<script>
export default {
  props: ["stations", "selectedStation"],
  methods: {
    updateStation(e) {
      this.$emit("stationChanged", e.target.value);
    }
  }
};
</script>

<style scoped>
.result {
  padding: 5px 0;
}
.result select {
  width: 100%;
}
</style>
